var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33333 1.33334C5.70152 1.33334 6 1.63182 6 2.00001V2.66668H10V2.00001C10 1.63182 10.2985 1.33334 10.6667 1.33334C11.0349 1.33334 11.3333 1.63182 11.3333 2.00001V2.66668H12C13.1046 2.66668 14 3.56211 14 4.66668V12.6667C14 13.7713 13.1046 14.6667 12 14.6667H4C2.89544 14.6667 2 13.7713 2 12.6667V4.66668C2 3.56211 2.89543 2.66668 4 2.66668H4.66667V2.00001C4.66667 1.63182 4.96514 1.33334 5.33333 1.33334ZM4.66667 4.00001H4C3.63181 4.00001 3.33333 4.29849 3.33333 4.66668V6.00001H12.6667V4.66668C12.6667 4.29848 12.3682 4.00001 12 4.00001H11.3333V4.66668C11.3333 5.03487 11.0349 5.33334 10.6667 5.33334C10.2985 5.33334 10 5.03487 10 4.66668V4.00001H6V4.66668C6 5.03487 5.70152 5.33334 5.33333 5.33334C4.96514 5.33334 4.66667 5.03487 4.66667 4.66668V4.00001ZM12.6667 7.33334H3.33333V12.6667C3.33333 13.0349 3.6318 13.3333 4 13.3333H12C12.3682 13.3333 12.6667 13.0349 12.6667 12.6667V7.33334Z",
    fill: "black",
    fillOpacity: 0.37
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 8H4.33333C4.14924 8 4 8.14924 4 8.33333V9.66667C4 9.85076 4.14924 10 4.33333 10H5.66667C5.85076 10 6 9.85076 6 9.66667V8.33333C6 8.14924 5.85076 8 5.66667 8Z",
    fill: "black",
    fillOpacity: 0.37
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 8H7.33333C7.14924 8 7 8.14924 7 8.33333V9.66667C7 9.85076 7.14924 10 7.33333 10H8.66667C8.85076 10 9 9.85076 9 9.66667V8.33333C9 8.14924 8.85076 8 8.66667 8Z",
    fill: "black",
    fillOpacity: 0.37
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 8H10.3333C10.1492 8 10 8.14924 10 8.33333V9.66667C10 9.85076 10.1492 10 10.3333 10H11.6667C11.8508 10 12 9.85076 12 9.66667V8.33333C12 8.14924 11.8508 8 11.6667 8Z",
    fill: "black",
    fillOpacity: 0.37
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.23cc343805c98c3369df7c9690cbbf3d.svg";
export { ForwardRef as ReactComponent };